import React, { Component } from 'react';
import './DeleteConfirmationPopup.css';
import Card from '../card/Card';
import Label from '../label/Label';
import Button from '../button/Button';
import Popup from '../popup/Popup';

export default class DeleteConfirmationPopup extends Component {
	constructor(props) {
		super(props);
		this.confirmation = props.confirmation || `Are you sure you want to delete this ${this.props.name}?`
		this.title = props.title || `Delete`
	}
	render() {
		return (
			<Popup show={this.props.show} className="g-delete-confirmation-popup" onClose={this.props.onClose}>
				<Card>
					<Label larger black>
						{' '}
						{this.title}
					</Label>
					<Label black>{ this.confirmation }</Label>
					<div className="button-row">
						<Button center bg="red" color="white" onClick={this.props.onConfirm}>
							Yes
						</Button>
						<Button center bg="blue" color="white" onClick={this.props.onClose}>
							No
						</Button>
					</div>
				</Card>
			</Popup>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/deleteConfirmationPopup/DeleteConfirmationPopup.jsx